import { InjectionToken } from '@angular/core';

export const APP_ENVIRONMENT = new InjectionToken<
  Record<string, string | boolean>
>('APP_ENVIRONMENT');
